import React from 'react'
import InternshipSectionDevops from '../Internships/components/Internshipdevops'

const Devops = () => {
  return (
    <>

      <div className='container my-5 enroll'>
        <div className='row py-5  '>

          <div className=" col-md-6 ">
            <div className='mt-5 px-5 me-3'>
              <div className="">
                <h3 className="course-heading  " >DevOps Development</h3>
                <p className="text-justify ">DevOps is a set of practices that combines software development (Dev) and IT operations
                  (Ops) to automate and enhance the software delivery process. Its goal is to reduce the
                  development cycle time, increase the frequency of deployments, and increase product
                  quality through CI (continuous integration), CD (continuous delivery) and automation.
                  DevOps are utilized tools as Jenkins, Docker, Kubernetes and cloud platforms (AWS,
                  Azure) use to automate development, deployment, and monitoring, developing a
                  collaboration between development and operations, for efficient and stable software
                  delivery.</p>

              </div>  </div>
          </div>
          <div className=' col-md-6  ' >
            <div className='mt-2'>
              <img className="img-fluid mx-auto d-flex" width="100%" src={require('../../assets/images/Hire-our-Wordpress-Developer.png')} /> </div>
          </div></div>
      </div>
      <InternshipSectionDevops />
    </>
  )
}

export default Devops